import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment-timezone';
import PPanel from 'primevue/panel';
import PButton from 'primevue/button';
import PDivider from 'primevue/divider';
import PTag from 'primevue/tag';
import BSaleEndTimer from '~/components/general/BSaleEndTimer.vue';
import BActionsModal from '~/components/general/BActionsModal.vue';
import IconInfoCircle from '~/components/common/icons/InfoCircle.vue';
import IconArrowDown from '~/components/general/icons/IconArrowDown.vue';
import { EVENT_STATES, calculateSmallerPrice, sortByDisplayOrder } from '~/utils/utils';
import { ConditionalTicketValidator } from '~/utils/order/conditionals';
export default /*#__PURE__*/_defineComponent({
  __name: 'TicketPriceList',
  props: {
    ticketConfig: {
      default: function _default() {
        return [];
      }
    },
    ticketDiscounts: {
      default: function _default() {
        return [];
      }
    },
    eventStatus: {
      default: ''
    },
    ownedTickets: {
      default: function _default() {
        return [];
      }
    },
    selectedTickets: {
      default: function _default() {
        return [];
      }
    },
    selectedTimeslot: {
      default: null
    }
  },
  emits: ['remove', 'add', 'openLogin'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var auth = useAuth();
    var notifier = useNotifier();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var showInfoDialog = ref(false);
    var selectedTicketConfigName = ref('');
    var selectedTicketConfigDescription = ref('');
    var eventStates = EVENT_STATES;
    var validator = new ConditionalTicketValidator();
    var collapsedPanels = ref({});
    var isCanceledEvent = computed(function () {
      return props.eventStatus === eventStates.CANCELED;
    });
    var eventInDraft = computed(function () {
      return props.eventStatus === eventStates.DRAFT;
    });
    var timeslotHasLimitedCapacity = computed(function () {
      var _props$selectedTimesl, _props$selectedTimesl2;
      return ((_props$selectedTimesl = (_props$selectedTimesl2 = props.selectedTimeslot) === null || _props$selectedTimesl2 === void 0 ? void 0 : _props$selectedTimesl2.ticketConfigCapacity) !== null && _props$selectedTimesl !== void 0 ? _props$selectedTimesl : 0) > 0;
    });
    var getSelectedTicketsInTimeslot = computed(function () {
      return props.selectedTickets.filter(function (selectedTicket) {
        var _props$selectedTimesl3;
        return selectedTicket.timeslotId === ((_props$selectedTimesl3 = props.selectedTimeslot) === null || _props$selectedTimesl3 === void 0 ? void 0 : _props$selectedTimesl3.id);
      }).map(function (selectedTicket) {
        return selectedTicket.id;
      });
    });
    var ticketConfigCapacityReached = computed(function () {
      var _props$selectedTimesl4;
      if (!props.selectedTimeslot || !timeslotHasLimitedCapacity.value) {
        return false;
      }
      var selectedTicketsIds = getSelectedTicketsInTimeslot.value;
      var ticketConfigIds = _toConsumableArray(new Set([].concat(_toConsumableArray(selectedTicketsIds), _toConsumableArray((_props$selectedTimesl4 = props.selectedTimeslot.associatedTicketConfig) !== null && _props$selectedTimesl4 !== void 0 ? _props$selectedTimesl4 : []))));
      return (ticketConfigIds === null || ticketConfigIds === void 0 ? void 0 : ticketConfigIds.length) === props.selectedTimeslot.ticketConfigCapacity;
    });
    var timeslotSoldOut = computed(function () {
      var _props$selectedTimesl5, _getSelectedTicketsIn;
      return ((_props$selectedTimesl5 = props.selectedTimeslot) === null || _props$selectedTimesl5 === void 0 ? void 0 : _props$selectedTimesl5.availableTickets) - ((_getSelectedTicketsIn = getSelectedTicketsInTimeslot.value) === null || _getSelectedTicketsIn === void 0 ? void 0 : _getSelectedTicketsIn.length) <= 0;
    });
    function panelHasSelectedTickets(config) {
      return config.discounts.some(function (discount) {
        return discount.selectedQuantity > 0;
      });
    }
    function calculateTotal(discount) {
      return (discount.finalPrice + discount.fees) * discount.selectedQuantity;
    }
    function togglePanel(configId) {
      var current = collapsedPanels.value[configId] !== undefined ? collapsedPanels.value[configId] : props.ticketConfig.length !== 1;
      collapsedPanels.value = _objectSpread(_objectSpread({}, collapsedPanels.value), {}, _defineProperty({}, configId, !current));
    }
    function isPanelCollapsed(config) {
      return collapsedPanels.value[config.id] !== undefined ? collapsedPanels.value[config.id] : props.ticketConfig.length !== 1;
    }
    function discountIsUsable(discount) {
      var _discount$availableTi, _discount$minQuantity;
      return ((_discount$availableTi = discount === null || discount === void 0 ? void 0 : discount.availableTickets) !== null && _discount$availableTi !== void 0 ? _discount$availableTi : 0) >= ((_discount$minQuantity = discount === null || discount === void 0 ? void 0 : discount.minQuantity) !== null && _discount$minQuantity !== void 0 ? _discount$minQuantity : 0);
    }

    // checks if user didn't select more tickets that they can buy at this point
    function maxNotReached(tc) {
      return tc.ticketsPerUser - Number(tc.userHolds) - Number(tc.amountOfTicketInCart) > 0;
    }
    function isSoldOut(config) {
      return Boolean(config.availableTickets <= 0 || config.quantity <= 0 || config.ended || !config.started);
    }
    function ticketConfigIsSelectable(ticketConfig) {
      var _props$selectedTimesl6, _props$selectedTimesl7, _props$selectedTimesl8;
      if (!ticketConfigCapacityReached.value) {
        return true;
      }
      var selectedTicketsIds = getSelectedTicketsInTimeslot.value;
      var ticketConfigAlreadyInTimeslot = (_props$selectedTimesl6 = (_props$selectedTimesl7 = props.selectedTimeslot) === null || _props$selectedTimesl7 === void 0 ? void 0 : (_props$selectedTimesl8 = _props$selectedTimesl7.associatedTicketConfig) === null || _props$selectedTimesl8 === void 0 ? void 0 : _props$selectedTimesl8.includes(ticketConfig.id)) !== null && _props$selectedTimesl6 !== void 0 ? _props$selectedTimesl6 : false;
      var ticketConfigAlreadyInCart = selectedTicketsIds.includes(ticketConfig.id);
      return ticketConfigAlreadyInTimeslot || ticketConfigAlreadyInCart;
    }
    function findDiscount(discountId) {
      return props.ticketDiscounts.find(function (td) {
        return td.id === discountId;
      });
    }
    function isDiscountSoldOut(discount) {
      var foundDiscount = findDiscount(discount === null || discount === void 0 ? void 0 : discount.id);
      if (!foundDiscount) {
        return false;
      }
      return foundDiscount.availableTickets <= 0 || !discountIsUsable(foundDiscount);
    }
    function isDisabled(config, discount) {
      return Boolean(config.discount.selectedQuantity === config.ticketsPerUser || isCanceledEvent.value || eventInDraft.value || isSoldOut(config) || isDiscountSoldOut(discount) || !ticketConfigIsSelectable(config) || timeslotSoldOut.value);
    }
    function configIsConditional(config) {
      var _config$dependsOn$len, _config$dependsOn;
      return ((_config$dependsOn$len = config === null || config === void 0 ? void 0 : (_config$dependsOn = config.dependsOn) === null || _config$dependsOn === void 0 ? void 0 : _config$dependsOn.length) !== null && _config$dependsOn$len !== void 0 ? _config$dependsOn$len : 0) > 0;
    }
    function conditionalConfigText(config) {
      var _config$dependsOn$map, _config$dependsOn2;
      return (_config$dependsOn$map = config === null || config === void 0 ? void 0 : (_config$dependsOn2 = config.dependsOn) === null || _config$dependsOn2 === void 0 ? void 0 : _config$dependsOn2.map(function (tc) {
        return tc === null || tc === void 0 ? void 0 : tc.name;
      }).join(', ')) !== null && _config$dependsOn$map !== void 0 ? _config$dependsOn$map : '';
    }

    // Validate if the order would be valid if we added a ticket of `ticketConfig` type
    // to the combination of tickets in cart and already owned tickets
    function conditionalTicketingSatisfied(ticketConfig) {
      if (!configIsConditional(ticketConfig)) {
        return true;
      }
      return validator.canAddTicket(ticketConfig, props.ownedTickets, props.selectedTickets);
    }
    function discountAvailable(discount) {
      if (!discount.id) {
        return true;
      }
      var now = moment();
      return now.isSameOrAfter(moment(discount.startAt)) && now.isSameOrBefore(moment(discount.endAt));
    }
    function discountAvailabilityInfo(discount) {
      var now = moment();
      if (discount !== null && discount !== void 0 && discount.startAt && now.isBefore(moment(discount.startAt))) {
        return t('cart.discountNotStarted');
      }
      if (discount !== null && discount !== void 0 && discount.endAt && now.isAfter(moment(discount.endAt))) {
        return t('cart.discountEnded');
      }
      return '';
    }
    function smallerPrice(config) {
      return calculateSmallerPrice(config);
    }
    function ticketAvailabilityLevel(ticketConfig) {
      if (isCanceledEvent.value || !ticketConfigIsSelectable(ticketConfig)) {
        return t('cart.notAvailable');
      }
      if (ticketConfig.availableTickets <= 0) {
        if (maxNotReached(ticketConfig)) {
          return t('cart.soldOut').toUpperCase();
        } else {
          return t('buyTickets.maxReached').toUpperCase();
        }
      }
      if (!ticketConfig.started) {
        return t('cart.ticketSaleNotStarted');
      }
      if (ticketConfig.ended) {
        return t('cart.discountEnded');
      }
      if (timeslotSoldOut.value) {
        return t('cart.soldOut').toUpperCase();
      }
      return "".concat(t('main.from'), " ").concat(smallerPrice(ticketConfig));
    }
    function showTicketInfoDialog(config) {
      var _config$description;
      showInfoDialog.value = true;
      selectedTicketConfigName.value = config.name;
      selectedTicketConfigDescription.value = (_config$description = config.description) !== null && _config$description !== void 0 ? _config$description : '';
    }
    function closeTicketInfoDialog() {
      showInfoDialog.value = false;
    }
    function add(config, discount) {
      if (!conditionalTicketingSatisfied(config)) {
        // Logged-out users may own the prerequisite, which we only see after login
        if (!auth.loggedIn) {
          emit('openLogin');
          return;
        }
        notifier.showMessage({
          content: t('conditional.error.message', {
            ticket: conditionalConfigText(config)
          }),
          type: 'error'
        });
        return;
      }
      emit('add', {
        ticket: config,
        discount: discount
      });
    }
    function displaySaleEndTimer(config) {
      var endingMoment = moment(config.endSaleAt);
      var now = moment();
      var endsSoon = endingMoment.diff(now, 'days') <= 30;
      return Boolean(config.showSaleEndTimer && configOnSale(config) && endsSoon);
    }
    function configOnSale(config) {
      return Boolean(config.started && !config.ended);
    }
    var sortedTicketConfig = computed(function () {
      return sortByDisplayOrder(props.ticketConfig).map(function (config) {
        var isCollapsed = collapsedPanels.value[config.id] !== undefined ? collapsedPanels.value[config.id] : props.ticketConfig.length !== 1;
        return _objectSpread(_objectSpread({}, config), {}, {
          collapsed: isCollapsed
        });
      });
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      auth: auth,
      notifier: notifier,
      t: t,
      showInfoDialog: showInfoDialog,
      selectedTicketConfigName: selectedTicketConfigName,
      selectedTicketConfigDescription: selectedTicketConfigDescription,
      eventStates: eventStates,
      validator: validator,
      collapsedPanels: collapsedPanels,
      isCanceledEvent: isCanceledEvent,
      eventInDraft: eventInDraft,
      timeslotHasLimitedCapacity: timeslotHasLimitedCapacity,
      getSelectedTicketsInTimeslot: getSelectedTicketsInTimeslot,
      ticketConfigCapacityReached: ticketConfigCapacityReached,
      timeslotSoldOut: timeslotSoldOut,
      panelHasSelectedTickets: panelHasSelectedTickets,
      calculateTotal: calculateTotal,
      togglePanel: togglePanel,
      isPanelCollapsed: isPanelCollapsed,
      discountIsUsable: discountIsUsable,
      maxNotReached: maxNotReached,
      isSoldOut: isSoldOut,
      ticketConfigIsSelectable: ticketConfigIsSelectable,
      findDiscount: findDiscount,
      isDiscountSoldOut: isDiscountSoldOut,
      isDisabled: isDisabled,
      configIsConditional: configIsConditional,
      conditionalConfigText: conditionalConfigText,
      conditionalTicketingSatisfied: conditionalTicketingSatisfied,
      discountAvailable: discountAvailable,
      discountAvailabilityInfo: discountAvailabilityInfo,
      smallerPrice: smallerPrice,
      ticketAvailabilityLevel: ticketAvailabilityLevel,
      showTicketInfoDialog: showTicketInfoDialog,
      closeTicketInfoDialog: closeTicketInfoDialog,
      add: add,
      displaySaleEndTimer: displaySaleEndTimer,
      configOnSale: configOnSale,
      sortedTicketConfig: sortedTicketConfig,
      PPanel: PPanel,
      PButton: PButton,
      PDivider: PDivider,
      PTag: PTag,
      BSaleEndTimer: BSaleEndTimer,
      BActionsModal: BActionsModal,
      IconInfoCircle: IconInfoCircle,
      IconArrowDown: IconArrowDown
    };
  }
});